import BaseHttpService from 'JS/services/BaseHttpService';
import CyberSourceMicroformsService from 'JS/checkout/services/CyberSourceMicroformsService';
import LoggerService from 'JS/services/LoggerService';
import { AutomotiveSchedulerAppointmentService, IAutomotiveSchedulerAppointmentService } from './AutomotiveSchedulerAppointmentService';
import { AutomotiveSchedulerPaymentService, IAutomotiveSchedulerPaymentService } from './AutomotiveSchedulerPaymentService';
import { AutomotiveSchedulerStepService, IAutomotiveSchedulerStepService } from './AutomotiveSchedulerStepService';
import { createSchedulerEventDispatcher, SchedulerEventDispatcher } from 'JS/automotive/analytics';
import { ILoggerService } from 'JS/types/Logger';
import { inject, InjectionKey, provide } from 'vue';

export interface IServiceRegistry {
	stepService: IAutomotiveSchedulerStepService,
	appointmentService: IAutomotiveSchedulerAppointmentService,
	logService: ILoggerService,
	dispatchSchedulerEvent: SchedulerEventDispatcher,
	paymentService: IAutomotiveSchedulerPaymentService,
	cyberSourceMicroformsService: CyberSourceMicroformsService
}

export const ServiceRegistry: IServiceRegistry = {
	stepService: new AutomotiveSchedulerStepService(),
	appointmentService: new AutomotiveSchedulerAppointmentService(),
	logService: new LoggerService(),
	dispatchSchedulerEvent: createSchedulerEventDispatcher(window.blainGtmDataLayer),
	paymentService: new AutomotiveSchedulerPaymentService(),
	cyberSourceMicroformsService: new CyberSourceMicroformsService(new BaseHttpService())
};


const injectionKey: InjectionKey<Readonly<IServiceRegistry>> = Symbol('auto-scheduler-services');

/**
 * Provides an IServiceRegistry for dependency injection. NOTE: you may pass a partial IServiceRegistry object for simplified
 * use in testing, but be aware that the type system will not warn you of undefined services.
 * @param services Definition of IServiceRegistry. Defaults to ServiceRegistry
 */
export function provideServices(services: Partial<IServiceRegistry> = Object.freeze(ServiceRegistry)) {
	provide(injectionKey, services);
}

/**
 * Composable for injecting services from the Service Registry
 *
 * @returns The IServiceRegistry provided higher in the component tree
 */
export function useServices() {
	return inject(injectionKey)!;
}